import { render, staticRenderFns } from "./QuickShare.vue?vue&type=template&id=4919f4d4&"
import script from "./QuickShare.vue?vue&type=script&lang=js&"
export * from "./QuickShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports